import { render, staticRenderFns } from "./BiddingForm.pug?vue&type=template&id=5b99743c&scoped=true&lang=pug&"
import script from "./BiddingForm.vue?vue&type=script&lang=js&"
export * from "./BiddingForm.vue?vue&type=script&lang=js&"
import style0 from "./BiddingForm.scss?vue&type=style&index=0&id=5b99743c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99743c",
  null
  
)

export default component.exports